export const appRoles = {
  abaADMIN: 'ABA Admin',
  bdataADMIN: 'BData Administrator',
  qualityAssurance: 'Quality Assurance',
  qualityImprovement: 'Quality Improvement',
  registrar: 'Registrar',
  powerUser: 'Power User',
  superUser: 'Super User',
  reportViewer: 'Report Viewer',
  summaryReportViewer: 'Summary Report Viewer',
  manager: 'Manager',
  verification: 'Verification',
  burnCenterUser: 'Burn Center User',
};

export const Roles = {
  bdataAdmin: 'bdata_administrator',
  abaAdmin: 'aba_admin',
  manager: 'manager',
  burnCenterUser: 'burn_center_user',
};
export const RolesLabels = {
  [Roles.bdataAdmin]: 'BData Administrator',
  [Roles.abaAdmin]: 'ABA Administrator',
  [Roles.manager]: 'Burn Center Administrator',
  [Roles.burnCenterUser]: 'Burn Center User',
};

export const ReviewStatusLabels = {
  NotStarted: 'Not Started',
  Requested: 'Requested',
  Started: 'Started',
  PRQLocked: 'PRQ Locked',
  MeetingAndRoundsLocked: 'Meetings & Rounds Locked',
  ReviewedBySiteReviewer: 'Under Committee Review',
  Concluded: 'Concluded',
  Closed: 'Closed',
};

export const applicationState = {
  NotStarted: 'NotStarted',
  Requested: 'Requested',
  Started: 'Started',
  PRQLocked: 'PRQLocked',
  MeetingAndRoundsLocked: 'MeetingAndRoundsLocked',
  ReviewedBySiteReviewer: 'ReviewedBySiteReviewer',
  Concluded: 'Concluded',
  Closed: 'Closed',
};

export const applicationStateLabels = {
  [applicationState.NotStarted]: ReviewStatusLabels.NotStarted,
  [applicationState.Requested]: ReviewStatusLabels.Requested,
  [applicationState.Started]: ReviewStatusLabels.Started,
  [applicationState.PRQLocked]: ReviewStatusLabels.PRQLocked,
  [applicationState.MeetingAndRoundsLocked]:
    ReviewStatusLabels.MeetingAndRoundsLocked,
  [applicationState.ReviewedBySiteReviewer]:
    ReviewStatusLabels.ReviewedBySiteReviewer,
  [applicationState.Concluded]: ReviewStatusLabels.Concluded,
  [applicationState.Closed]: ReviewStatusLabels.Closed,
};

export const applicationStatus = {
  RecommendVerification: 'RecommendVerification',
  RecommendDeferVerification: 'RecommendDeferVerification',
  Verification: 'Verification',
  NonVerification: 'NonVerification',
  NonVerificationPendingReview: 'NonVerificationPendingReview',
};

export const applicationStatusLabels = {
  [applicationStatus.RecommendVerification]: 'Recommend Verification Visit',
  [applicationStatus.RecommendDeferVerification]:
    'Recommend Defer Verification Visit',
  [applicationStatus.Verification]: 'Verification',
  [applicationStatus.NonVerification]: 'Non Verification',
  [applicationStatus.NonVerificationPendingReview]:
    'Non Verification Pending Review',
};

export const ReportingRoleEnum = {
  DASHBOARD: 'Dashboard Viewer',
  ALL_REPORTS: 'All Reports Viewer',
  EXPLORER: 'Explorer',
};

export const abaVerifiedLabels = {
  Yes: 'Yes',
  No: 'No',
  Unknown: 'Unknown',
};

export const abaVerificationTypeLabels = {
  Adult: 'Adult',
  Pediatric: 'Pediatric',
  AdultAndPediatric: 'Adult and Pediatric',
  Unknown: 'Unknown',
};

export const BurncenterAccessLevelEnum = {
  NO_ACCESS: 'No Access',
  VERIFICATION_ONLY: 'Verification Only',
  ANALYTICS_ONLY: 'Analytics Only',
  BCQP_LITE: 'BCQP Lite',
  FULL_PLATFORM: 'Full Platform',
  BURN_CENTER_CLOSED: 'Burn Center Closed',
  OTHER: 'Other',
};

export const ProgramTypeLabels = {
  BurnCenter: 'Burn Center',
  Fellowship: 'Fellowship',
  FocusReview: 'Focus Review',
};

export const ProgramTypeAndSubTypeLabel = {
  BurnCenterVerification: 'Burn Center - Verification',
  BurnCenterReverification: 'Burn Center - Reverification',
  BurnCenterConsultationOnly: 'Burn Center - Consultation Only',
  BurnCenterFocusReview: 'Burn Center - Focus Review',
  FellowshipVerification: 'Fellowship - Verification',
  FellowshipReverification: 'Fellowship - Reverification',
  FellowshipProvisionalVerification: 'Fellowship - Provisional Verification',
};

export const getProgramTypeFromApplicationType = (applicationType) => {
  if (!applicationType) return null;
  if (applicationType.startsWith('Fellowship')) {
    return ProgramTypeLabels.Fellowship;
  }
  if (applicationType.startsWith('BurnCenter')) {
    return ProgramTypeLabels.BurnCenter;
  }
  return null;
};

export const getSubTypeFromApplicationType = (applicationType) => {
  if (!applicationType) return null;
  const subTypeMap = {
    FellowshipVerification: 'verification',
    FellowshipReverification: 're verification',
    FellowshipProvisionalVerification: 'provisional verification',
    BurnCenterVerification: 'verification',
    BurnCenterReverification: 're verification',
    BurnCenterConsultationOnly: 'consultation only',
    BurnCenterFocusReview: 'focused review',
  };
  return subTypeMap[applicationType] || null;
};

const DataUploadBaseLabels = {
  CallForData2026: {
    long: 'Current Call for Data XML/XFR - 2026 Call for Data (Admissions from Jan 1, 2025 - Dec 31, 2025)',
    short: '2026 Call for Data',
  },
  CallForData2025: {
    long: 'Current Call for Data XML/XFR - 2025 Call for Data (Admissions from Jan 1, 2024 - Dec 31, 2024)',
    short: '2025 Call for Data',
  },
  CallForData2024: {
    long: '2024 Call for Data XML/XFR - 2024 Call for Data (Admissions from Jan 1, 2023 - Dec 31, 2023)',
    short: '2024 Call for Data',
  },
  CallForData2023: {
    long: '2023 Call for Data (Admissions from Jan 1, 2022 - Dec 31, 2022)',
    short: '2023 Call for Data',
  },
  CallForDataOther: {
    long: 'Other Call for Data XML/XFR - Prior Years or Resubmittal',
    short: 'Other Call for Data',
  },
  DataMigration: {
    long: 'Historical data migration',
    short: 'Data Migration',
  },
};

export const DataUploadLabels = Object.fromEntries(
  Object.entries(DataUploadBaseLabels).map(([key, value]) => [key, value.long]),
);

export const DataUploadShortLabels = Object.fromEntries(
  Object.entries(DataUploadBaseLabels).map(([key, value]) => [
    key,
    value.short,
  ]),
);

export const DataUploadOptions = Object.entries(DataUploadLabels)
  .filter(
    ([key]) => !['CallForData2023', 'CallForData2024', 'CallForData2025'].includes(key),
  )
  .map(([value, label]) => ({ value, label }));

export const ContentCategoryLabels = {
  GettingStarted: 'Getting Started',
  DataEntry: 'Data Entry',
  CallForData: 'Call for Data',
  Reporting: 'Reporting',
  Verification: 'Verification',
  QiPiFeatures: 'QI/PI Features',
  UserManagement: 'User Management',
  SecurityCompliance: 'Security/Compliance',
  DataDictionary: 'Data Dictionary',
  All: 'All',
};

export const BurnCenterTabLabels = {
  About: 'About',
  BenchmarkCriteria: 'Bed Capacity',
  Users: 'Users',
  Admin: 'Admin',
};
